<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="PROUNI" />
        <div v-if="!showLoading && $featureToggle && $featureToggle.INTEGRA_PROUNI">
            <div v-if="dadosAba.anoInclusao || dadosAba.codigoMantenedora" class="md-layout content-dados">

                <div class="md-layout-item md-size-50">
                    <md-list class="md-double-line md-dense">
                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4" v-formatdate="dadosAba.dataAtualizacao"></span>
                                <span class="s-h3 regular">Última atualização</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.codigoMantenedora}} - {{dadosAba.mantenedora}}</span>
                                <span class="s-h3 regular">Mantenedora</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.codigoIes}} - {{dadosAba.ies}}</span>
                                <span class="s-h3 regular">IES</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.codigoLocalOferta}} - {{dadosAba.localOferta}}</span>
                                <span class="s-h3 regular">Local</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.codigoCurso}} - {{dadosAba.curso}}</span>
                                <span class="s-h3 regular">Curso</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.bolsaPermanencia}}</span>
                                <span class="s-h3 regular">Bolsa Permanencia</span>
                            </div>
                        </md-list-item>
                    </md-list>
                </div>
                <div class="md-layout-item md-size-50">
                    <md-list class="md-double-line md-dense">

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.anoInclusao}}{{dadosAba.semestreInclusao}}</span>
                                <span class="s-h3 regular">Período de Concessão</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.tipoBolsa}}</span>
                                <span class="s-h3 regular">Tipo de Bolsa</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.descricaoStatusBolsa}}</span>
                                <span class="s-h3 regular">Situação Bolsista</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4">{{dadosAba.situacaoBolsista}}</span>
                                <span class="s-h3 regular">Descrição da Situação</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4" v-formatdate="dadosAba.dataAssinaturaConcessao" />
                                <span class="s-h3 regular">Data da Assinatura</span>
                            </div>
                        </md-list-item>

                        <md-list-item>
                            <div class="md-list-item-text mostrarMaisMenos">
                                <span class="s-h4" v-formatdate="dadosAba.dataAssinaturaEncerramento" />
                                <span class="s-h3 regular">Data da Assinatura Encerramento</span>
                            </div>
                        </md-list-item>

                    </md-list>
                </div>
            </div>
            <div v-else>
                <md-empty-state class="content"
                                md-icon="block"
                                md-label="Nenhum registro encontrado"
                                md-description="O aluno não possui PROUNI.">
                </md-empty-state>
            </div>
        </div>
    </Loading>
</template>

<script>
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import ProuniService from '@/services/ProuniService.js';
    import { formatdate } from '@/directives/formatdate.js';

    export default {
        name: 'Prouni',
        components: {
            Loading,
            PageTitle
        },
        data() {
            return {
                dadosAba: null,
                showLoading: false,
                prouniService: null
            }
        },
        directives: {
            formatdate,
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home')
            }
            else {
                //Coloca o perfil de aluno disponível na variável aluno
                let a = JSON.parse(sessionStorage.Aluno);

                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se a aba ja está carregada
                    if (a.Prouni) {
                        this.dadosAba = a.Prouni;
                    }
                }
                else {
                    this.$router.push('home');
                }
            }

            this.prouniService = new ProuniService(this);

            console.log("Antes do feature toggle");
            if (this.$featureToggle.INTEGRA_PROUNI) {
                //Verifica se a aba não está carregada
                if (!this.dadosAba) {
                    //Popula os dados da aba
                    this.showLoading = true;
                    this.prouniService.ConsultarProuni({
                        Cpf: this.aluno.cpf
                    }).then(
                        data => {
                            console.log(data);
                            if (data.ok) {
                                this.dadosAba = data.dados.prouni;
                            }
                            else {
                                this.$modal.info(data.Mensagem);
                            }
                        },
                        error => {
                            if (error.status != 500)
                                this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            else
                                this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        }).finally(() => {
                            this.showLoading = false;
                        });
                }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.Prouni = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        }
    }
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
        margin-top: 2rem;
        margin: 0 auto;
    }

    .content-dados {
        margin: 2rem;
    }

    .mostrarMaisMenos {
        white-space: normal;
    }
</style>
